import { useInvalidate } from '@refinedev/core'
import { PLATFORM_ACTIVITY_RESOURCE } from '~/providers/dataProvider'

/**
 * After a user write: the list and the user's page read the user again, and
 * their History (platform events) lists the new events.
 */
export function useUserRefresh() {
  const invalidate = useInvalidate()
  return (id: string) =>
    Promise.all([
      invalidate({
        resource: 'users',
        invalidates: ['list', 'detail'],
        id,
      }),
      invalidate({
        resource: PLATFORM_ACTIVITY_RESOURCE,
        invalidates: ['list'],
      }),
    ])
}
